import { render, staticRenderFns } from "./whiteList.vue?vue&type=template&id=477b2286&scoped=true"
import script from "./whiteList.vue?vue&type=script&lang=js"
export * from "./whiteList.vue?vue&type=script&lang=js"
import style0 from "./whiteList.vue?vue&type=style&index=0&id=477b2286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477b2286",
  null
  
)

export default component.exports